module.exports = __webpack_public_path__ + "static/media/05 4 01.33487faa.png";